import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'icon-check',
  standalone: true,
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd"
            d="M1.25 12c0 5.9371 4.81294 10.75 10.75 10.75 5.9371 0 10.75-4.8129
            10.75-10.75 0-5.93706-4.8129-10.75-10.75-10.75C6.06294 1.25 1.25
            6.06294 1.25 12Zm15.4257-3.73715c.4071.37319.4346 1.00576.0615
            1.41288l-5.5 5.99997c-.1844.2011-.4428.3181-.7155.3241-.2727.0059-.53594-.0998-.72881-.2927l-2.5-2.5c-.39052-.3905-.39052-1.0237
            0-1.4142.39053-.3905 1.02369-.3905 1.41422 0l1.76149 1.7615 4.7942-5.23012c.3732-.40712 1.0058-.43462 1.4129-.06143Z"
            clip-rule="evenodd" />
    </svg>
  `
})
export class IconCheckComponent {
  size: InputSignal<number> = input<number>(24);
}
